import {HttpClient} from '@angular/common/http';
import {PublisherInvoice} from '../domain/publisher-invoice.model';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpUtils} from '../utils/http-utils';
import {InvoicesResponse} from '../domain/invoices-response.model';
import {PublisherFileUpload} from '../domain/publisher-file-upload.model';
import {Page} from '../domain/page.model';

@Injectable()
export class PublisherFilesService {

  constructor(private http: HttpClient) {
  }

  listAllFiles(pubId: string, page: number, size: number, sortField: string, sortDirection: string, fileName?: string): Observable<Page<PublisherFileUpload>> {
    return this.http.get<Page<PublisherFileUpload>>(`${environment.serviceUrl}/ad-stats/publisher-files/all`, {
      params: HttpUtils.getHttpParams({
        publisherId: pubId,
        page: page,
        size: size,
        sortField: sortField ? [sortField] : null,
        sortDirection: sortDirection,
        fileName: fileName,
      })
    });
  }

  createFile(pubId: string, file: File, description: string): Observable<PublisherFileUpload> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    if(description){
      formData.append('description', description);
    }
    return this.http.post<PublisherFileUpload>(`${environment.serviceUrl}/ad-stats/publisher-files/${pubId}`, formData);
  }

  importAppCsvFile(file: File): Observable<PublisherFileUpload> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<PublisherFileUpload>(`${environment.serviceUrl}/ad-stats/publisher-products/app-import`, formData);
  }

  updateFile(file: PublisherFileUpload): Observable<PublisherFileUpload> {
    return this.http.put<PublisherFileUpload>(`${environment.serviceUrl}/ad-stats/publisher-files/${file.id}`, file);
  }

  deleteFile(file: PublisherFileUpload) {
    return this.http.delete(`${environment.serviceUrl}/ad-stats/publisher-files/${file.id}`);
  }


}
